import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import useTendering from "../../../hooks/useTendering";
import useQuotation from "../../../hooks/useQuotation";
import TenderingDetailContext from "../context";
import List, { STATE } from "../../../components/List";
import { format } from "date-fns";
import { ReactComponent as EveSvg } from "../../../assets/tendering/eye.svg";
import { ReactComponent as DownloadSvg } from "../../../assets/tendering/download.svg";
import { toast } from "react-toastify";

const assetsUri = import.meta.env.ASSETS_URI;

const Schedules = (props) => {
  const { details } = useContext(TenderingDetailContext);
  const {} = useTendering();
  const { queryQuotation } = useQuotation();
  const [datasource, setDatasource] = useState([]);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  // const [metadata, setMetadata] = useState(undefined);
  const [fetchingState, setFetchingState] = useState(STATE.LOADING);

  useEffect(() => {
    _refetch();
  }, []);

  const _refetch = (_limit, _page) => {
    setDatasource(
      details.contractor.schedules.map((schedule) => {
        return {
          name: schedule.name,
          date: format(new Date(schedule.createdOn), "dd MMM yyyy"),
          actions: (
            <div className="tendering-documents__schedules__list__actions">
              <div
                className="tendering-documents__schedules__list__actions__action"
                onClick={() =>
                  handleDownload(schedule.name, `${assetsUri}/${schedule.key}`)
                }
              >
                <DownloadSvg width={18} height={18} />
              </div>
            </div>
          ),
        };
      })
    );
    setFetchingState(STATE.IDLE);
  };

  const handleDownload = async (fileName, path) => {
    await toast.promise(
      new Promise(async (resolve, reject) => {
        const res = await fetch(path, { cache: "no-cache" });
        const blob = await res.blob();

        saveAs(blob, fileName);

        resolve();
      }),
      {
        pending: "Downloading",
        success: "File downloaded",
        error: "Failed to download",
      },
      {
        autoClose: 1000,
      }
    );
  };

  return (
    <div className="tendering-documents__schedules">
      <h2>Master Schedules</h2>
      <List
        contentState={fetchingState}
        scrollable={true}
        columns={[
          {
            display: "File name",
            key: "name",
            textAlign: "left",
          },
          {
            display: "Submitted on",
            key: "date",
            textAlign: "left",
            width: 100,
          },
          {
            display: "",
            key: "actions",
            textAlign: "left",
          },
        ]}
        dataSource={datasource}
      ></List>
    </div>
  );
};

Schedules.propTypes = {};

export default Schedules;
